import { Course } from '@insta-club/models';
import Image from 'next/image';
import Link from 'next/link';

function CourseItem({ course }: { course: Course }) {
    return (
        <Link href={`/courses/${course.id}`}>
            <div className='relative aspect-video h-full w-full overflow-hidden rounded-2xl'>
                <div
                    className='absolute inset-0 z-[1] flex flex-col items-start justify-end'
                    style={{
                        background:
                            'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 0.01%, rgba(0, 0, 0, 0.656458) 60.92%, rgba(0, 0, 0, 0.8) 95.84%)'
                    }}
                >
                    {/* <div className='m-2 flex items-center self-end rounded-[18px] bg-gray-800/80 p-1 pl-2 backdrop-blur-xs'>
                        <Image
                            className='ml-1 h-7 w-7 rounded-full object-cover'
                            width={28}
                            height={28}
                            src={course.teacher.image ?? '/img-not-found-placeholder.jpg'}
                            alt={course.description}
                            loading='lazy'
                        />
                        <span className='text-xs font-semibold text-gray-100'>
                            {course.teacher.first_name} {course.teacher.last_name}
                        </span>
                    </div> */}
                    <div className='flex w-full items-center justify-between p-3'>
                        <h4 className='line-clamp-1 text-sm font-bold text-white'>{course.title}</h4>
                        <div className='flex items-center justify-end'>
                            {/* <div className='flex items-center rounded-lg bg-gray-800 p-1.5 text-xs text-gray-200'>
                                <ClockIcon className='ml-1' />
                                <span>
                                    {course.hours} ساعت و {course.minutes} دقیقه
                                </span>
                            </div> */}
                            {course.is_new && (
                                <span className='bg-primary-50 text-primary-600 rounded-sm px-2 py-1 text-xs font-medium'>
                                    جدیدترین
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <Image
                    src={course.image ?? '/img-not-found-placeholder.jpg'}
                    alt={course.title}
                    fill
                    priority
                    sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
                    className='object-cover'
                />
            </div>
        </Link>
    );
}

export default CourseItem;

